import { HTMLAttributes } from "react"
import styled from "@emotion/styled"

export const ActivityGrid = styled.div`
  display: grid;
  grid-gap: 30px;
`
